import { capitalize } from "../../../utils/stringUtils";
export var getRecipeIcon = function (recipe) {
    if (recipe.product && recipe.product.length > 0) {
        return getIconFromRecipeName(recipe);
    }
    return "XpIcn";
};
var getIconFromRecipeName = function (recipe) {
    var name = recipe.visualName || recipe.name || "";
    name = capitalize(name.replace(/_.*/, ""));
    return name + "Icn";
};



//////////////////
// WEBPACK FOOTER
// ./src/features/generic/icon/getRecipeIcon.ts
// module id = 575
// module chunks = 3